import React from 'react';
import { MODAL_REGISTRY } from './registry';

export type ModalKey = keyof typeof MODAL_REGISTRY;

export const ModalKeyContext = React.createContext<ModalKey | undefined>(
  undefined
);
